import { apiClient } from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';

export const getChatMessages = async (chatId: string) => {
  return await apiClient.get(`${ENDPOINTS.CHATS}/${chatId}`);
};
